// extracted by mini-css-extract-plugin
export default {"root":"PaywallFaqV1_root-sTl","item":"PaywallFaqV1_item-HjN","question":"PaywallFaqV1_question-z7s","chevron":"PaywallFaqV1_chevron-r5T","answer":"PaywallFaqV1_answer-uBR"};